// extracted by mini-css-extract-plugin
export default {"netFacilityChart":"yoJB4z"};